import React, { useEffect, useState } from "react";
import { Col, Container, Row} from "react-bootstrap";
import { Field, useFormikContext } from "formik";
import "./SelectButton";
import { useSelector } from "react-redux";
import { selectProfile } from "../../store/slices/profile-slice";
import { GeneralSelect } from "../Custom-Forms/General-Select";
import Button from "react-bootstrap/Button";
import MaskedInput from "react-text-mask";
import "./Profile.css";
import PhoneInput from "react-phone-number-input";
import nnLogo from "../Images/navajo_nation_seal.png";
import "react-toastify/dist/ReactToastify.css";
import {  FaTrashAlt} from "react-icons/fa";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
import { GeneralRadioGroupInput } from "../Custom-Forms/General-Radio-Group-Input";
import { GrCheckbox, GrCheckboxSelected } from "react-icons/gr";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FaRegFilePdf } from "react-icons/fa";
import Swal from "sweetalert2";
import Card from "react-bootstrap/Card";
import prettyBytes from "pretty-bytes";
import { STATES } from "./util/states.js";
import { ethnicity } from "./util/ethnicity.js";
import { positionStatus } from "./util/positionStatus.js";
import {
    formateUploadDate,
    genderOptions,
    formatDateToInputFormat,
} from "./util/helpers.js";
import { FileUpload } from "../File-Upload/File-Upload";
import { FileUploadDelete } from "../File-Upload/File-Upload-Delete";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify'

export const PersonalInformation = () => {
    const { values, setFieldValue, setValues, errors } =
        useFormikContext();

    const [arePersonalInfoFilled, setArePersonalInfoFilled] = useState(false);
    const [uploadCIB, setUploadCIB] = useState(false); //CIB
    const [uploadRIF, setUploadRIF] = useState(false); //RIF
    const [uploadDD214, setUploadDD214] = useState(false); // DD214/215
    const [uploadVeteranPrefApp, setUploadVeteranPrefApp] = useState(false); // VETERAN PREF APP
    const [uploadSpouseCIB, setUploadSpouseCIB] = useState(false); // SPOUSE CIB
    const [uploadSpouseAffidavit, setUploadSpouseAffidavit] = useState(false); // SPOUSE AFFIDAVIT
    const [uploadMarriageLicense, setUploadMarriageLicense] = useState(false); // SPOUSE MARRIAGE LICNESE

    const navigate = useNavigate()
    const selectedJob = JSON.parse(localStorage.getItem('storedJob'))
    const ToastID = React.useRef(null)

    // On initial application form load
    // If selected job is empty go to /jobs page and display warning
    useEffect(() => {
        if (
            selectedJob === null || selectedJob.requisitionID === ""
        ) {
            ToastID.current = toast.warning(`No Job Selected. Please Select a Job and Try Again`, { theme: "colored", containerId: "root", autoClose: 5000, position: "top-center" })
            navigate("/jobs");
        }
    }, [selectedJob, navigate]);


    const requiredFields = (values) => {

        return (
            values.firstName &&
            values.lastName &&
            values.phoneNumber &&
            values.dob &&
            values.gender &&
            values.addressLine1 &&
            values.city &&
            values.state &&
            values.zipcode &&
            values.gender
        );

    }

    const [enrollmentStatus, setEnrollmentStatus] = useState(
        values.census ? "Yes" : "No",
    );

    const handleRadioChange = (event) => {
        setEnrollmentStatus(event.target.value);
        if (event.target.value === "Yes") {
            setFieldValue("nationality", "Navajo");
        } else {
            setFieldValue("nationality", "");
        }
    };

    useEffect(() => {
        if (enrollmentStatus === "Yes") {
            setFieldValue("nationality", "Navajo");
        }
    }, [setFieldValue, enrollmentStatus]);


    const profile = useSelector(selectProfile);
    let spouseCensus = profile.NN_SpouseCensus;

    const suffixOptions = [
        "Jr.",
        "Sr.",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
    ];

    useEffect(() => {

        setArePersonalInfoFilled(requiredFields(values));
    }, [
        values.firstName,
        values.lastName,
        values.phoneNumber,
        values.dob,
        values.gender,
        values.addressLine1,
        values.city,
        values.state,
        values.zipcode,
        values.gender,
    ]);
    return (
        <>
            <Container className="container2 px-3 justify-content-center">
                {arePersonalInfoFilled && (
                    <>
                        <div
                            className="alert alert-success text-center success-msg animate__animated animate__fadeInUp mt-2 mb-0"
                            role="alert"
                        >
                            <h4 className="alert-heading fw-bold fs-5 fs-md-4">
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    style={{
                                        color: "cornflowerblue",
                                        fontSize: "1.5em",
                                    }}
                                    className="fa-fw fa-xs d-md-inline-block me-md-2 pt-1 "
                                />
                            </h4>
                            Great! You can proceed to the next step.
                        </div>
                    </>
                )}


                <Card className="mt-4 full-width-card ">
                    <Card.Header className="d-flex justify-content-center position-relative align-items-center bottom-border w-100 mx-auto">
                        <h3 className="header-font"><span>Personal Information</span></h3>

                        <Button
                            className="transparent-btn position-absolute end-0"
                            onClick={async () => {
                                let result = await Swal.fire({
                                    title: "Are you sure?",
                                    text: "You won't be able to revert this!",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor:
                                        "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText:
                                        "Yes, delete it!",
                                });

                                if (result.isConfirmed) {
                                    let valuesCopy = {
                                        ...values,
                                    };
                                    valuesCopy.suffix = "";
                                    valuesCopy.firstName = "";
                                    valuesCopy.lastName = "";
                                    valuesCopy.middleName = "";
                                    valuesCopy.phoneNumber = "";
                                    valuesCopy.dob = "";
                                    valuesCopy.gender = "";
                                    valuesCopy.addressLine1 =
                                        "";
                                    valuesCopy.addressLine2 =
                                        "";
                                    valuesCopy.city = "";
                                    valuesCopy.state = "";
                                    valuesCopy.zipcode = "";
                                    setValues(valuesCopy);
                                }
                            }}
                        >
                            <FaTrashAlt
                                className="icon trash-icon"
                                style={{ fontSize: "20px" }}
                            />
                        </Button>
                    </Card.Header>
                   {/* <Card.Header className="d-flex flex-column flex-md-row justify-content-md-between align-items-start bottom-border w-100 mx-auto">

                        <div className="mt-2 mt-md-0  d-flex justify-content-around justify-content-md-end w-100">

                                    <div className="d-flex align-items-center">
                                        <Button
                                            className="transparent-btn ml-2"
                                            onClick={async () => {
                                                let result = await Swal.fire({
                                                    title: "Are you sure?",
                                                    text: "You won't be able to revert this!",
                                                    icon: "warning",
                                                    showCancelButton: true,
                                                    confirmButtonColor:
                                                        "#3085d6",
                                                    cancelButtonColor: "#d33",
                                                    confirmButtonText:
                                                        "Yes, delete it!",
                                                });

                                                if (result.isConfirmed) {
                                                    let valuesCopy = {
                                                        ...values,
                                                    };
                                                    valuesCopy.suffix = "";
                                                    valuesCopy.firstName = "";
                                                    valuesCopy.lastName = "";
                                                    valuesCopy.middleName = "";
                                                    valuesCopy.phoneNumber = "";
                                                    valuesCopy.dob = "";
                                                    valuesCopy.gender = "";
                                                    valuesCopy.addressLine1 =
                                                        "";
                                                    valuesCopy.addressLine2 =
                                                        "";
                                                    valuesCopy.city = "";
                                                    valuesCopy.state = "";
                                                    valuesCopy.zipcode = "";
                                                    setValues(valuesCopy);
                                                }
                                            }}
                                        >
                                            <FaTrashAlt
                                                className="icon trash-icon"
                                                style={{ fontSize: "20px" }}
                                            />
                                        </Button>
                                    </div>
                        </div>
                    </Card.Header>*/}
                    <Card.Body className="customCard">

                        <Row className="d-flex justify-content-center">
                            <Row className="d-flex justify-content-center my-3">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        Suffix
                                    </label>
                                        <GeneralSelect name="suffix">
                                            <option value="">Select One</option>
                                            {suffixOptions.map((item) => {
                                                return (
                                                    <option
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </option>
                                                );
                                            })}
                                        </GeneralSelect>

                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-center my-3">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        First Name
                                    </label>

                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="input"
                                            rows="1"
                                            name="firstName"
                                        />

                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-center my-3">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        Middle Name
                                    </label>

                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="input"
                                            rows="1"
                                            name="middleName"
                                        />

                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-center my-3">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        Last Name
                                    </label>

                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="input"
                                            rows="1"
                                            value={values.lastName}
                                            name="lastName"
                                        />

                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-center my-3">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        Phone Number
                                    </label>

                                        <Field name="phoneNumber">
                                            {({ field, meta }) => (
                                                <div>
                                                    <PhoneInput
                                                        international
                                                        countryCallingCodeEditable={
                                                            false
                                                        }
                                                        defaultCountry="US"
                                                        placeholder="Enter phone number"
                                                        {...field}
                                                        onChange={(
                                                            phoneNumber,
                                                        ) => {
                                                            const changedEvent =
                                                            {
                                                                target: {
                                                                    name: "phoneNumber",
                                                                    value: phoneNumber,
                                                                },
                                                            };
                                                            field.onChange(
                                                                changedEvent,
                                                            );
                                                        }}
                                                    />
                                                    {meta.touched &&
                                                        meta.error && (
                                                            <div className="text-danger ">
                                                                {meta.error}
                                                            </div>
                                                        )}
                                                </div>
                                            )}
                                        </Field>

                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-center my-3">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        Date of Birth
                                    </label>

                                        <div style={{ width: "229px" }}>
                                            <GeneralTextAreaField
                                                className="form-control"
                                                type="date"
                                                name="dob"
                                                value={formatDateToInputFormat(
                                                    values.dob,
                                                )}
                                                placeholder="MM/DD/YYYY"
                                            />
                                        </div>

                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-center my-3">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        Gender
                                    </label>

                                        <GeneralSelect name="gender">
                                            <option value="">Select One</option>
                                            {genderOptions.map((item) => {
                                                return (
                                                    <option
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </option>
                                                );
                                            })}
                                        </GeneralSelect>

                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-center my-3">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        Address Line 1
                                    </label>

                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="2"
                                            name="addressLine1"
                                            placeholder="Street Address or P.O. Box"
                                            maxLength={200}
                                        />

                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-center my-3">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        Address Line 2
                                    </label>

                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="addressLine2"
                                            placeholder="Apartment or Suite #"
                                            maxLength={200}
                                        />

                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-center my-3">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        City
                                    </label>

                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="input"
                                            rows="1"
                                            name="city"
                                        />

                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-center my-3">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        State
                                    </label>

                                        <GeneralSelect name="state">
                                            <option value="">Select One</option>
                                            {STATES.map((item) => {
                                                return (
                                                    <option
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </option>
                                                );
                                            })}
                                        </GeneralSelect>

                                </Col>
                            </Row>

                            <Row className="d-flex justify-content-center pb-2 mt-3 mb-4">
                                <Col xs={11} lg={6}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        Zipcode
                                    </label>

                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="input"
                                            rows="1"
                                            name="zipcode"
                                        />

                                </Col>
                            </Row>
                        </Row>
                    </Card.Body>
                </Card>

                <Row className="d-flex justify-content-center">
                    <Col className="col-auto pt-3">
                        <h3 className="header-font"><span>Preference Information</span></h3>
                    </Col>
                </Row>
                <Row>
                    <p></p>
                </Row>

                <Row className="d-flex justify-content-center w-100 my-3 mx-auto">
                    <Col xs={"auto"}>
                        <label className="info-label text-center mx-auto pt-1">
                            Are you an enrolled member of the Navajo tribe?
                        </label>
                    </Col>
                </Row>

                <Row
                    className=" d-flex justify-content-center"
                    style={{ marginTop: "-12px" }}
                >
                    <Col className="mt-3" xs={"auto"}>
                        <label className="fw-bold mx-3">
                            <input
                                type="radio"
                                value="Yes"
                                checked={enrollmentStatus === "Yes"}
                                onChange={handleRadioChange}
                                style={{
                                    scale: "1.5",
                                    marginRight: "7px",
                                }}
                            />
                            Yes
                        </label>
                        <label className="fw-bold">
                            <input
                                type="radio"
                                value="No"
                                checked={enrollmentStatus === "No"}
                                onChange={handleRadioChange}
                                style={{
                                    scale: "1.5",
                                    marginRight: "7px",
                                }}
                            />
                            No
                        </label>
                    </Col>
                </Row>

                {enrollmentStatus === "Yes" ? (
                    <>
                        <Card className="mt-4 full-width-card ">
                            <Card.Header
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <Card.Img
                                    variant="top"
                                    className="small-image"
                                    src={nnLogo}
                                />
                                <h4> Navajo Nation CIB</h4>
                            </Card.Header>
                            <Card.Body className="mt-1">
                                <Row className="mx-auto">
                                    <Row className="d-flex justify-content-center mx-auto">
                                        <Card.Subtitle className="mt-3 mb-1 mx-5 fs-5">
                                            As a Navajo Tribal
                                            member you are eligible for a hiring preference.
                                            To qualify the applicant must be an
                                            enrolled member of the Navajo Nation
                                            and provide verification by submitting their Census Number and Upload their CIB {"(Certificate of Indian Blood)"}.
                                        </Card.Subtitle>
                                        <br />
                                        <p className="justify-content-center text-center mb-0">
                                            For more information you can view
                                            the:&nbsp;
                                            <a
                                                target="_blank"
                                                rel="noopen noreferrer"
                                                href="https://www.dpm.navajo-nsn.gov/pages/policies/sections/IV.html"
                                            >
                                                Navajo Nation Personnel Policy
                                                Manual
                                            </a>
                                            <br />
                                            <span className="fw-bold">
                                                IV. Recruitment and Selection
                                            </span>
                                        </p>
                                        <Col xs={12} lg={6}>
                                            <label
                                                className="info-label text-center pt-1"
                                                style={{
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Census
                                            </label>

                                            <Field name="census">
                                                {({ field, meta }) => (
                                                    <>
                                                        <div>
                                                            <MaskedInput
                                                                mask={[
                                                                    /[0-9a-zA-Z]/,
                                                                    /[0-9a-zA-Z]/,
                                                                    /[0-9a-zA-Z]/,
                                                                    ",",
                                                                    /[0-9a-zA-Z]/,
                                                                    /[0-9a-zA-Z]/,
                                                                    /[0-9a-zA-Z]/,
                                                                ]}
                                                                className={`form-control ${meta.touched
                                                                    ? meta.error
                                                                        ? "is-invalid"
                                                                        : "is-valid"
                                                                    : ""
                                                                    }`}
                                                                {...field}
                                                            />
                                                            {meta.touched &&
                                                                meta.error ? (
                                                                <div className="invalid-feedback">
                                                                    {meta.error}
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </>
                                                )}
                                            </Field>
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <label
                                                className="info-label text-center pt-1"
                                                style={{
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Ethnicity
                                            </label>

                                            <Field
                                                as={GeneralSelect}
                                                name="nationality"
                                                className="form-control"
                                                disabled
                                            >
                                                <option value="">
                                                    Select One
                                                </option>
                                                {ethnicity.map(
                                                    (item, index) => (
                                                        <option
                                                            key={index}
                                                            value={item}
                                                        >
                                                            {item}
                                                        </option>
                                                    ),
                                                )}
                                            </Field>
                                        </Col>
                                    </Row>
                                </Row>
                            </Card.Body>
                            <Card.Header
                                style={{
                                    display: "flex",

                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <h4 className="border-bottom border-warning border-5">
                                    &nbsp;
                                    Upload CIB:
                                </h4>
                            </Card.Header>

                            {values.cibFormIn === "Yes" && (
                                <Card.Body className="pb-0">
                                    <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                        <Col className="py-3">
                                            <Row>
                                                <Col className="text-center">
                                                    <h5 className="border-bottom border-warning border-5">
                                                        CIB On File:
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>File Name:</b>&nbsp;
                                                    {
                                                        profile.NN_CIBForm_OriginalName
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Upload Date:</b>&nbsp;
                                                    {formateUploadDate(
                                                        profile.NN_CIBForm_UploadDate,
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Size:</b>&nbsp;
                                                    {profile.NN_CIBForm_FileSize
                                                        ? prettyBytes(
                                                            parseInt(
                                                                profile.NN_CIBForm_FileSize,
                                                            ),
                                                        )
                                                        : ""}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <FileUploadDelete
                                                    containerName={"NN_CIBForm"}
                                                    fileName={
                                                        profile.NN_CIBForm_OriginalName
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            )}

                            {uploadCIB && (
                                <FileUpload containerName={"NN_CIBForm"} />
                            )}
                            {profile.cibFormIn === "No" && !uploadCIB && (
                                <Col className="d-flex justify-content-center my-4">
                                    <Button
                                        variant="primary"
                                        className={
                                            uploadCIB ? "btn-danger" : ""
                                        }
                                        onClick={() => setUploadCIB(!uploadCIB)}
                                    >
                                        {uploadCIB
                                            ? "Cancel"
                                            : "Upload New CIB"}
                                    </Button>
                                </Col>
                            )}
                            <Card.Footer>
                                <Row className="d-flex justify-content-center text-center">
                                    <Col sm={6} xs={12} className="mb-3">
                                        <h5>
                                            <u>
                                                Required Information:
                                            </u>
                                        </h5>
                                        {values.census === "" && (
                                            <h5>
                                                <GrCheckbox />
                                                &nbsp;Enter your Census number.
                                            </h5>
                                        )}
                                        {values.census !== "" && (
                                            <h5>
                                                <GrCheckboxSelected className="text-success" />
                                                &nbsp;Census Number:&nbsp;{values.census}
                                            </h5>
                                        )}
                                        {values.cibFormIn === "No" && (
                                            <h5>
                                                <GrCheckbox />
                                                &nbsp;<FaRegFilePdf />
                                                CIB is required.
                                            </h5>
                                        )}
                                        {values.cibFormIn === "Yes" && (
                                            <h5>
                                                <GrCheckboxSelected className="text-success" />
                                                &nbsp;
                                                <FaRegFilePdf />
                                                &nbsp;CIB has been submitted.
                                            </h5>
                                        )}
                                    </Col>
                                    <Col sm={6} xs={12}>
                                        <h5>
                                            <u>
                                                Navajo Preference Status:
                                            </u>
                                        </h5>
                                        {enrollmentStatus === "Yes" &&
                                            (values.census === "" ||
                                                values.cibFormIn === "No") && (
                                                <>
                                                    <h5 className="text-danger">
                                                        Currently not eligible for preference.
                                                    </h5>
                                                    <p className="text-danger fst-italic">
                                                        Please provide your census number and uplaod your CIB.
                                                    </p>
                                                </>
                                            ) ||
                                            (values.census !== "" &&
                                                values.cibFormIn === "Yes") && (
                                                <h5 className="text-success">
                                                    Currently Eligible
                                                </h5>
                                            )}
                                    </Col>
                                </Row>
                            </Card.Footer>
                        </Card>
                    </>
                ) : (
                    <>
                        <Row className="d-flex justify-content-center w-100 animate__animated animate__slideInUp animate__faster mt-2 mx-auto">
                            <Col xs={12} lg={6}>
                                <label
                                    className="info-label text-center pt-1"
                                    style={{
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    Ethnicity
                                </label>

                                <Field
                                    as={GeneralSelect}
                                    name="nationality"
                                    className="form-control"
                                    onChange={(event) => {
                                        setFieldValue(
                                            "nationality",
                                            event.target.value,
                                        );
                                        if (event.target.value !== "Navajo") {
                                            setFieldValue("census", "");
                                        }
                                    }}
                                >
                                    <option value="">Select One</option>
                                    {ethnicity.map((item, index) => (
                                        <option key={index} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </Field>
                            </Col>
                            {values.nationality === "Navajo" && (
                                <>
                                    <Row className="d-flex justify-content-center mt-2 mb-0">
                                        <p className="text-muted w-auto fst-italic fs-5 fw-bold text-center">
                                            NOTE: In order to recieve Navajo Preference you must select &quot;Yes&quot; and provide the required information.
                                        </p>
                                    </Row>
                                </>
                            )}
                        </Row>
                    </>
                )}

                {enrollmentStatus === "Yes" ? (
                    <></>
                ) : (
                    <>
                        &nbsp;
                        <Row className="d-flex justify-content-center mt-1 top-border mx-auto">
                            <Col xs={"auto"} className="pt-1 mx-1 mt-2">
                                <label className="info-label text-center px-0 mx-0 w-auto">
                                    Are you married to a Navajo tribal member?
                                </label>
                            </Col>
                        </Row>
                        <Col className="d-flex justify-content-center">
                            <GeneralRadioGroupInput name="NN_Spouse" />
                        </Col>
                        {values.NN_Spouse === "Yes" && (
                            <>
                                <Card className="mt-4  full-width-card ">
                                    <Card.Header
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <Card.Img
                                            variant="top"
                                            className="small-image"
                                            src={nnLogo}
                                        />
                                        <h4>Spouse Navajo Nation CIB</h4>
                                    </Card.Header>

                                    <Card.Subtitle className="mt-3 mx-5 fs-5">
                                        {/* If you&apos;re a Non-Navajo spouse, you
                                        may qualify for hiring preference. Do
                                        note, however, that the Department of
                                        Personnel Management must provide
                                        written consent for this. */}
                                        As a Non-Navajo spouse, you may qualify for hiring preference. The Department of Personnel Management must provide written consent for this as well as have all the required information.
                                    </Card.Subtitle>
                                    <Card.Body className="h-100 d-flex justify-content-center mb-0 pb-0">
                                        <Row>
                                            <p className="text-center">
                                                For more information you can
                                                view the:&nbsp;
                                                <a
                                                    target="_blank"
                                                    rel="noopen noreferrer"
                                                    href="https://www.dpm.navajo-nsn.gov/pages/policies/sections/IV.html"
                                                >
                                                    Navajo Nation Personnel
                                                    Policy Manual
                                                </a>
                                                <br />
                                                <span className="fw-bold">
                                                    IV-G. Recruitment and
                                                    Selection : Referrals
                                                </span>
                                            </p>
                                        </Row>
                                    </Card.Body>
                                    <Row className="w-100 mx-auto mt-0 p-0">
                                        <Row className="d-flex justify-content-center mx-auto mb-2">
                                            <Col xs={12} lg={6}>
                                                <label
                                                    className="info-label text-center pt-1"
                                                    style={{
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Spouse Census
                                                </label>

                                                <Field name="NN_SpouseCensus">
                                                    {({ field, meta }) => (
                                                        <>
                                                            <div>
                                                                <MaskedInput
                                                                    mask={[
                                                                        /[0-9a-zA-Z]/,
                                                                        /[0-9a-zA-Z]/,
                                                                        /[0-9a-zA-Z]/,
                                                                        ",",
                                                                        /[0-9a-zA-Z]/,
                                                                        /[0-9a-zA-Z]/,
                                                                        /[0-9a-zA-Z]/,
                                                                    ]}
                                                                    className={`form-control ${meta.touched
                                                                        ? meta.error
                                                                            ? "is-invalid"
                                                                            : "is-valid"
                                                                        : ""
                                                                        }`}
                                                                    {...field}
                                                                />
                                                                {meta.touched &&
                                                                    meta.error ? (
                                                                    <div className="invalid-feedback">
                                                                        {
                                                                            meta.error
                                                                        }
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        </>
                                                    )}
                                                </Field>
                                            </Col>
                                        </Row>
                                    </Row>

                                    <Card.Header
                                        style={{
                                            display: "flex",

                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <h5 className="border-bottom border-warning border-5">
                                            Upload Spouse CIB
                                        </h5>
                                    </Card.Header>

                                    <Card.Body className="pb-0">
                                        {profile.NN_SpouseCIBFormIn ===
                                            "Yes" && (
                                                <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                                    <Col className="py-3">
                                                        <Row>
                                                            <Col className="text-center">
                                                                <h5 className="border-bottom border-warning border-5">
                                                                    {" "}
                                                                    Current Spouse
                                                                    CIB On File:
                                                                </h5>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <b>File Name: </b>{" "}
                                                                {
                                                                    profile.NN_SpouseCIBForm_OriginalName
                                                                }
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <b>Upload Date:</b>{" "}
                                                                {formateUploadDate(
                                                                    profile.NN_SpouseCIBForm_UploadDate,
                                                                )}
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <b>Size:</b>{" "}
                                                                {profile.NN_SpouseCIBForm_FileSize
                                                                    ? prettyBytes(
                                                                        parseInt(
                                                                            profile.NN_SpouseCIBForm_FileSize,
                                                                        ),
                                                                    )
                                                                    : ""}
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <FileUploadDelete
                                                                containerName={
                                                                    "NN_SpouseCIBForm"
                                                                }
                                                                fileName={
                                                                    profile.NN_SpouseCIBForm_OriginalName
                                                                }
                                                            />
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            )}
                                    </Card.Body>
                                    {uploadSpouseCIB && (
                                        <FileUpload
                                            containerName={"NN_SpouseCIBForm"}
                                        />
                                    )}

                                    {profile.NN_SpouseCIBFormIn === "No" &&
                                        !uploadSpouseCIB && (
                                            <Col className="d-flex justify-content-center mb-4">
                                                <Button
                                                    variant="primary"
                                                    className={
                                                        uploadSpouseCIB
                                                            ? "btn-danger"
                                                            : ""
                                                    }
                                                    onClick={() =>
                                                        setUploadSpouseCIB(
                                                            !uploadSpouseCIB,
                                                        )
                                                    }
                                                >
                                                    {uploadSpouseCIB
                                                        ? "Cancel"
                                                        : "Upload New Spouse CIB"}
                                                </Button>
                                            </Col>
                                        )}
                                    <Card.Header
                                        style={{
                                            display: "flex",

                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <h5 className="border-bottom border-warning border-5">
                                            Upload Marriage License
                                        </h5>
                                    </Card.Header>

                                    <Card.Body className="pb-0">
                                        {profile.NN_SpouseMarriageLicenseFormIn ===
                                            "Yes" && (
                                                <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                                    <Col className="py-3">
                                                        <Row>
                                                            <Col className="text-center">
                                                                <h5 className="border-bottom border-warning border-5">
                                                                    {" "}
                                                                    Current Marriage
                                                                    License On File:
                                                                </h5>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <b>File Name: </b>{" "}
                                                                {
                                                                    profile.NN_SpouseMarriageLicenseForm_OriginalName
                                                                }
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <b>Upload Date:</b>{" "}
                                                                {formateUploadDate(
                                                                    profile.NN_SpouseMarriageLicenseForm_UploadDate,
                                                                )}
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <b>Size:</b>{" "}
                                                                {profile.NN_SpouseMarriageLicenseForm_FileSize
                                                                    ? prettyBytes(
                                                                        parseInt(
                                                                            profile.NN_SpouseMarriageLicenseForm_FileSize,
                                                                        ),
                                                                    )
                                                                    : ""}
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <FileUploadDelete
                                                                containerName={
                                                                    "NN_SpouseMarriageLicenseForm"
                                                                }
                                                                fileName={
                                                                    profile.NN_SpouseMarriageLicenseForm_OriginalName
                                                                }
                                                            />
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            )}
                                    </Card.Body>
                                    {uploadMarriageLicense && (
                                        <FileUpload
                                            containerName={
                                                "NN_SpouseMarriageLicenseForm"
                                            }
                                        />
                                    )}

                                    {profile.NN_SpouseMarriageLicenseFormIn ===
                                        "No" &&
                                        !uploadMarriageLicense && (
                                            <Col className="d-flex justify-content-center mb-4">
                                                <Button
                                                    variant="primary"
                                                    className={
                                                        uploadMarriageLicense
                                                            ? "btn-danger"
                                                            : ""
                                                    }
                                                    onClick={() =>
                                                        setUploadMarriageLicense(
                                                            !uploadMarriageLicense,
                                                        )
                                                    }
                                                >
                                                    {uploadMarriageLicense
                                                        ? "Cancel"
                                                        : "Upload New Marriage License"}
                                                </Button>
                                            </Col>
                                        )}
                                    <Card.Header
                                        style={{
                                            display: "flex",

                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <h5 className="border-bottom border-warning border-5">
                                            Upload Affidavit of Navajo Residency
                                        </h5>
                                    </Card.Header>

                                    <Card.Body className="pb-0">
                                        {profile.NN_Spouse_ResidenceVerificationFormIn ===
                                            "Yes" && (
                                                <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                                    <Col className="py-3">
                                                        <Row>
                                                            <Col className="text-center">
                                                                <h5 className="border-bottom border-warning border-5">
                                                                    {" "}
                                                                    Current
                                                                    Affidavit of
                                                                    Navajo Residency
                                                                    On File:
                                                                </h5>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <b>File Name: </b>{" "}
                                                                {
                                                                    profile.NN_Spouse_ResidenceVerificationForm_OriginalName
                                                                }
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <b>Upload Date:</b>{" "}
                                                                {formateUploadDate(
                                                                    profile.NN_Spouse_ResidenceVerificationForm_UploadDate,
                                                                )}
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <b>Size:</b>{" "}
                                                                {profile.NN_Spouse_ResidenceVerificationForm_FileSize
                                                                    ? prettyBytes(
                                                                        parseInt(
                                                                            profile.NN_Spouse_ResidenceVerificationForm_FileSize,
                                                                        ),
                                                                    )
                                                                    : ""}
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <FileUploadDelete
                                                                containerName={
                                                                    "NN_Spouse_ResidenceVerificationForm"
                                                                }
                                                                fileName={
                                                                    profile.NN_Spouse_ResidenceVerificationForm_OriginalName
                                                                }
                                                            />
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            )}
                                    </Card.Body>
                                    {uploadSpouseAffidavit && (
                                        <FileUpload
                                            containerName={
                                                "NN_Spouse_ResidenceVerificationForm"
                                            }
                                        />
                                    )}
                                    {profile.NN_Spouse_ResidenceVerificationFormIn ===
                                        "No" &&
                                        !uploadSpouseAffidavit && (
                                            <Col className="d-flex justify-content-center mb-4">
                                                <Button
                                                    variant="primary"
                                                    className={
                                                        uploadSpouseAffidavit
                                                            ? "btn-danger"
                                                            : ""
                                                    }
                                                    onClick={() =>
                                                        setUploadSpouseAffidavit(
                                                            !uploadSpouseAffidavit,
                                                        )
                                                    }
                                                >
                                                    {uploadSpouseAffidavit
                                                        ? "Cancel"
                                                        : "Upload New Affidavit of Navajo Residency"}
                                                </Button>
                                            </Col>
                                        )}

                                    <Card.Footer>
                                        <Row className="d-flex justify-content-center text-center">
                                            <Col sm={6} xs={12} className="mb-3">
                                                <h5>
                                                    <u>
                                                        Required Information:
                                                    </u>
                                                </h5>
                                                <h6>
                                                    {values.NN_SpouseCensus ? (
                                                        <>
                                                            <GrCheckboxSelected className="text-success" />
                                                            &nbsp;
                                                            Spouse&apos;s Census number:
                                                            &nbsp;
                                                            {values.NN_SpouseCensus}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <GrCheckbox />
                                                            &nbsp;Enter your Spouse&apos;s Census number.
                                                        </>
                                                    )}
                                                </h6>
                                                <h6>
                                                    {profile.NN_SpouseCIBFormIn ===
                                                        "Yes" ? (
                                                        <>
                                                            <GrCheckboxSelected className="text-success" />
                                                            &nbsp;
                                                            Spouse CIB has been submitted.
                                                        </>
                                                    ) : (
                                                        <>
                                                            <GrCheckbox />
                                                            &nbsp;
                                                            Spouse CIB is required.
                                                        </>
                                                    )}
                                                </h6>
                                                <h6>
                                                    {profile.NN_SpouseMarriageLicenseFormIn ===
                                                        "Yes" ? (
                                                        <>
                                                            <GrCheckboxSelected className="text-success" />
                                                            &nbsp;
                                                            Marriage License has been submitted.
                                                        </>
                                                    ) : (
                                                        <>
                                                            <GrCheckbox />
                                                            &nbsp;
                                                            Marriage License is required.
                                                        </>
                                                    )}
                                                </h6>
                                                <h6>
                                                    {profile.NN_Spouse_ResidenceVerificationFormIn ===
                                                        "Yes" ? (
                                                        <>
                                                            <GrCheckboxSelected className="text-success" />
                                                            &nbsp;
                                                            Navajo Nation Residence Verification has been submitted.
                                                        </>
                                                    ) : (
                                                        <>
                                                            <GrCheckbox />
                                                            &nbsp;
                                                            Navajo Nation Residence Verification is required.
                                                        </>
                                                    )}
                                                    {/* &nbsp;
                                                    Verification
                                                    Residence on Navajo
                                                    for more than one
                                                    year. */}
                                                </h6>
                                                <p className="justify-content-start">
                                                    NOTE: Applicant MUST be a NN resident for minimum of a year.
                                                </p>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                {values.NN_Spouse === "Yes" &&
                                                    (values.NN_SpouseCensus === "" ||
                                                        profile.NN_SpouseCIBFormIn === "No" ||
                                                        profile.NN_SpouseMarriageLicenseFormIn === "No" ||
                                                        profile.NN_Spouse_ResidenceVerificationFormIn === "No") && (
                                                        <>
                                                            <h5>
                                                                <u>
                                                                    Navajo Spouse Preference Status:
                                                                </u>
                                                            </h5>
                                                            <h5 className="text-danger">
                                                                Currently not eligible for preference.
                                                            </h5>
                                                            <p className="text-danger fst-italic">
                                                                You are lacking ONE or MULTIPLE forms to be eligible for this preference.
                                                            </p>
                                                        </>
                                                    ) ||
                                                    (values.NN_SpouseCensus !== "" &&
                                                        profile.NN_SpouseCIBFormIn === "Yes" &&
                                                        profile.NN_SpouseMarriageLicenseFormIn === "Yes" &&
                                                        profile.NN_Spouse_ResidenceVerificationFormIn === "Yes") && (
                                                        <>
                                                            <h5>
                                                                <u>
                                                                    Navajo Spouse Preference Status:
                                                                </u>
                                                            </h5>
                                                            <h5 className="text-success">
                                                                Currently eligible
                                                                for preference.
                                                            </h5>
                                                        </>
                                                    )}
                                            </Col>
                                        </Row>
                                    </Card.Footer>
                                </Card>
                            </>
                        )}
                    </>
                )}

                <Row className="d-flex justify-content-center w-100 my-3 mx-auto border-top">
                    <Col xs={"auto"} className="mx-1 mt-2">
                        <label className="info-label text-center px-0 mx-0 pt-1 w-auto">
                            Are you currently employed with the Navajo Nation?
                        </label>
                    </Col>
                </Row>
                <Col className="d-flex justify-content-center ">
                    <GeneralRadioGroupInput name="currentlyEmployed" />
                </Col>
                {values.currentlyEmployed === "Yes" ? (
                    <>
                        <Card className="my-4 full-width-card ">

                            <Card.Header
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <Card.Img
                                    variant="top"
                                    className="small-image"
                                    src={nnLogo}
                                />
                                <h4>Navajo Nation Employment</h4>
                            </Card.Header>
                            <Card.Subtitle className="mt-3 mx-5 fs-5">
                                This information will determine your eligibility for applying to In-House advertisements.
                            </Card.Subtitle>
                            <br />
                            <Row className="mx-auto mb-3 d-flex justify-content-center mx-auto">
                                <Col xs={10} lg={7}>
                                    <label
                                        className="info-label text-center"
                                        style={{
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        AB Number:
                                    </label>
                                    <GeneralTextAreaField
                                        className="form-control"
                                        component="textarea"
                                        rows="1"
                                        name="AB_Number"
                                    />
                                </Col>
                                <Col xs={10} lg={7}>
                                    <label
                                        className="info-label text-center pt-1 pb-4"

                                    >
                                        Employment Status:
                                    </label>
                                    <Field
                                        as={GeneralSelect}
                                        name="Employment_Status"
                                        className="form-control"
                                    >
                                        <option value="">
                                            Select One
                                        </option>
                                        {positionStatus.map(
                                            (item, index) => (
                                                <option
                                                    key={index}
                                                    value={item}
                                                >
                                                    {item}
                                                </option>
                                            ),
                                        )}
                                    </Field>
                                </Col>
                                <Col xs={10} lg={7}>
                                    <label
                                        className="info-label text-center pt-1"
                                        style={{
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        Position Title:
                                    </label>
                                    <GeneralTextAreaField
                                        className="form-control"
                                        component="textarea"
                                        rows="1"
                                        name="Position_Title"
                                    />
                                </Col>
                            </Row>

                            <Card.Footer>
                                <Row className="d-flex justify-content-center text-center">
                                    <Col sm={12} xs={12}>
                                        <h5>
                                            <u>
                                                Required Information:
                                            </u>
                                        </h5>
                                        <h5>
                                            {values.AB_Number !==
                                                "" ? (
                                                <>
                                                    <GrCheckboxSelected className="text-success" />
                                                    &nbsp;
                                                    AB Number:
                                                    &nbsp;
                                                    {values.AB_Number}
                                                </>
                                            ) : (
                                                <>
                                                    <GrCheckbox />
                                                    &nbsp;
                                                    Enter your AB Number:
                                                </>
                                            )}
                                        </h5>
                                        <h5>
                                            {values.Employment_Status !==
                                                "" ? (
                                                <>
                                                    <GrCheckboxSelected className="text-success" />
                                                    &nbsp;
                                                    Employment Status:
                                                    &nbsp;
                                                    {values.Employment_Status}
                                                </>
                                            ) : (
                                                <>
                                                    <GrCheckbox />
                                                    &nbsp;
                                                    Enter your Employment Status:
                                                </>
                                            )}
                                        </h5>
                                        <h5>
                                            {values.Position_Title !==
                                                "" ? (
                                                <>
                                                    <GrCheckboxSelected className="text-success" />
                                                    &nbsp;
                                                    Position Title:
                                                    &nbsp;
                                                    {values.Position_Title}
                                                </>
                                            ) : (
                                                <>
                                                    <GrCheckbox />
                                                    &nbsp;
                                                    Enter your Position Title:
                                                </>
                                            )}
                                        </h5>
                                    </Col>
                                </Row>
                            </Card.Footer>
                        </Card>
                    </>
                ) : (
                    <></>
                )}

                <Row className="d-flex justify-content-center w-100 my-3 mx-auto border-top">
                    <Col xs={"auto"} className="mx-1 mt-2">
                        <label className="info-label text-center px-0 pt-1 w-auto">
                            Are you Unemployed due to Reduction in Force?
                        </label>
                    </Col>
                </Row>
                <Col className="d-flex justify-content-center ">
                    <GeneralRadioGroupInput name="rif" />
                </Col>
                {values.rif === "Yes" ? (
                    <>
                        <Card className="my-4 full-width-card ">

                            <Card.Header
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <Card.Img
                                    variant="top"
                                    className="small-image"
                                    src={nnLogo}
                                />
                                <h4>Re-Employment Preference</h4>
                            </Card.Header>
                            <Card.Subtitle className="mt-3 mx-5 fs-5">
                                The RIF priority can only be given to applicants that provide all the required information and the layoff date has to have occurred within the last 6 months.
                            </Card.Subtitle>
                            <br />
                            <p className="justify-content-center text-center">
                                For more information you can view the:&nbsp;
                                <a
                                    target="_blank"
                                    rel="noopen noreferrer"
                                    href="https://www.dpm.navajo-nsn.gov/pages/policies/sections/IV.html"
                                >
                                    Navajo Nation Personnel Policy Manual
                                </a>
                                <br />
                                <span className="fw-bold">
                                    IV-H. Recruitment and Selection :
                                    Re-Employment Preference
                                </span>
                            </p>
                            <Card.Header
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <Row>
                                    <h4 className="border-bottom border-warning border-5">
                                        &nbsp;
                                        Upload Layoff Notice/Letter:
                                    </h4>
                                </Row>
                            </Card.Header>
                            <br />
                            {values.rifFormIn === "Yes" && (
                                <Card.Body className="pb-0">
                                    <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-1 mb-2 border border-5">
                                        <Col className="py-3">
                                            <Row>
                                                <Col className="text-center">
                                                    <h5 className="border-bottom border-warning border-5">
                                                        Current Layoff
                                                        Notice/Letter On File:
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>File Name:</b>&nbsp;
                                                    {
                                                        profile.RIF_Form_OriginalName
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Upload Date:</b>&nbsp;
                                                    {formateUploadDate(
                                                        profile.RIF_Form_UploadDate,
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Size:</b>&nbsp;
                                                    {profile.RIF_Form_FileSize
                                                        ? prettyBytes(
                                                            parseInt(
                                                                profile.RIF_Form_FileSize,
                                                            ),
                                                        )
                                                        : ""}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <FileUploadDelete
                                                    containerName={"RIF_Form"}
                                                    fileName={
                                                        profile.RIF_Form_OriginalName
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            )}
                            {uploadRIF && (
                                <FileUpload containerName={"RIF_Form"} />
                            )}
                            {values.rifFormIn === "No" && !uploadRIF && (
                                <Col className="d-flex justify-content-center my-4">
                                    <Button
                                        variant="primary"
                                        className={
                                            uploadRIF ? "btn-danger" : ""
                                        }
                                        onClick={() => setUploadRIF(!uploadRIF)}
                                    >
                                        {uploadRIF
                                            ? "Cancel"
                                            : "Upload New Layoff Notice/Letter"}
                                    </Button>
                                </Col>
                            )}
                            <Card.Body>
                                <Row className="w-100 mx-auto">
                                    <Row className="d-flex justify-content-center mx-auto">
                                        <Col xs={12} lg={6}>
                                            <label
                                                className="info-label text-center pt-1"
                                                style={{
                                                    whiteSpace:
                                                        "nowrap",
                                                }}
                                            >
                                                Layoff Date:
                                            </label>
                                            <GeneralTextAreaField
                                                className="form-control"
                                                type="date"
                                                name="rifDate"
                                                placeholder="MM/DD/YYYY"
                                            />
                                        </Col>
                                    </Row>
                                </Row>
                            </Card.Body>

                            <Card.Footer>
                                <Row className="d-flex justify-content-center text-center">
                                    <Col sm={6} xs={12}>
                                        <h5>
                                            <u>
                                                Required Information:
                                            </u>
                                        </h5>
                                        <h5>
                                            {values.rifFormIn ===
                                                "Yes" ? (
                                                <>
                                                    <GrCheckboxSelected className="text-success" />
                                                    &nbsp;
                                                    Layoff Letter has been submitted.
                                                </>
                                            ) : (
                                                <>
                                                    <GrCheckbox />
                                                    &nbsp;
                                                    Layoff Letter is required.
                                                </>
                                            )}
                                        </h5>
                                        <h5>
                                            {values.rifDate ? (
                                                <>
                                                    <GrCheckboxSelected className="text-success" />
                                                    &nbsp;
                                                    Layoff Date:
                                                    &nbsp;
                                                    {values.rifDate}
                                                </>
                                            ) : (
                                                <>
                                                    <GrCheckbox />
                                                    &nbsp;
                                                    Layoff Date: Required
                                                </>
                                            )}
                                        </h5>
                                    </Col>
                                    <Col sm={6} xs={12} className="mb-3">
                                        <h5>
                                            <u>
                                                Navajo Re-Employment Preference Status:
                                            </u>
                                        </h5>
                                        {values.rif === "Yes" &&
                                            (values.rifFormIn === "Yes" &&
                                                values.rifDate !== "") && (
                                                <h5 className="text-success">
                                                    Currently eligible
                                                    for preference.
                                                </h5>
                                            ) ||
                                            (values.rifFormIn === "No" ||
                                                values.rifDate === "") && (
                                                <>
                                                    <div className="text-center">
                                                        <h5 className="text-danger underline">
                                                            Currently not eligible for preference.
                                                        </h5>
                                                        <p className="text-danger fst-italic">
                                                            You are lacking ONE or MULTIPLE forms to be eligible for this preference.
                                                        </p>
                                                    </div>
                                                </>
                                            )}
                                    </Col>
                                </Row>
                            </Card.Footer>
                        </Card>
                    </>
                ) : (
                    <>
                    </>
                )}

                <Row className="d-flex justify-content-center w-100 my-3 pt-1 mx-auto border-top">
                    <Col xs={"auto"}>
                        <label className="info-label text-center px-0 mx-0 pt-1 w-auto">
                            Are you a Veteran?
                        </label>
                    </Col>
                </Row>
                <Col className="d-flex justify-content-center mb-2">
                    <GeneralRadioGroupInput name="veteran" />
                </Col>
                {values.veteran === "Yes" && (
                    <>
                        <Card className="my-4  my-4 full-width-card ">
                            <Card.Header
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <Card.Img
                                    variant="top"
                                    className="small-image"
                                    src={nnLogo}
                                />
                                <h4>Veteran Preference</h4>
                            </Card.Header>
                            <Card.Subtitle className="mt-1 mx-5 mb-1">
                                <p className="fs-5">
                                    Eligible Veterans will receive preference
                                    for initial employment and a higher
                                    retention standing in the event of Layoffs.
                                    A Veteran discharged from the U.S. Armed
                                    Forces or the National Guard or Reserve
                                    under honorable conditions following more
                                    than 180 calendar days of active duty shall
                                    be given preference in employment.
                                </p>
                            </Card.Subtitle>
                            <p className="justify-content-center text-center mb-0">
                                For more information you can view the:&nbsp;
                                <a
                                    target="_blank"
                                    rel="noopen noreferrer"
                                    href="https://www.dpm.navajo-nsn.gov/pages/policies/sections/XIX.html"
                                >
                                    Navajo Nation Personnel Policy Manual
                                </a>
                                <br />
                                <span className="fw-bold">
                                    XIX. VETERANS PREFERENCE
                                </span>
                            </p>
                            <p className="justify-content-center text-center mb-0">
                                General Information:&nbsp;
                                <a
                                    className="text-center"
                                    target="_blank"
                                    rel="noopen noreferrer"
                                    href="/forms/Vet_Gen_Info_2013.pdf"
                                >
                                    Veterans Preference Information
                                </a>
                            </p>
                            <p className="justify-content-center text-center mb-3">
                                Application:&nbsp;
                                <a
                                    className="text-center"
                                    target="_blank"
                                    rel="noopen noreferrer"
                                    href="/forms/Fillable_Vet_Pref_App(1)Edit.pdf"
                                >
                                    Veteran Preference Application
                                </a>
                            </p>
                            <Card.Header
                                style={{
                                    display: "flex",

                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <h5 className="border-bottom border-warning border-5">
                                    Upload DD214/DD215
                                </h5>
                            </Card.Header>
                            <Card.Body className="pb-0">
                                {profile.DD214OnFile === "Yes" && (
                                    <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                        <Col className="py-3">
                                            <Row>
                                                <Col className="text-center">
                                                    <h5 className="border-bottom border-warning border-5">
                                                        &nbsp;
                                                        Current DD214/DD215 On
                                                        File:
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>File Name: </b>&nbsp;
                                                    {
                                                        profile.Veteran_DD214Form_OriginalName
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Upload Date:</b>&nbsp;
                                                    {formateUploadDate(
                                                        profile.Veteran_DD214Form_UploadDate,
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Size:</b>&nbsp;
                                                    {profile.Veteran_DD214Form_FileSize
                                                        ? prettyBytes(
                                                            parseInt(
                                                                profile.Veteran_DD214Form_FileSize,
                                                            ),
                                                        )
                                                        : ""}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <FileUploadDelete
                                                    containerName={
                                                        "Veteran_DD214Form"
                                                    }
                                                    fileName={
                                                        profile.Veteran_DD214Form_OriginalName
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                )}
                            </Card.Body>
                            {uploadDD214 && (
                                <FileUpload
                                    containerName={"Veteran_DD214Form"}
                                />
                            )}
                            {profile.DD214OnFile === "No" && !uploadDD214 && (
                                <Col className="d-flex justify-content-center mb-4">
                                    <Button
                                        variant="primary"
                                        className={
                                            uploadDD214 ? "btn-danger" : ""
                                        }
                                        onClick={() =>
                                            setUploadDD214(!uploadDD214)
                                        }
                                    >
                                        {uploadDD214
                                            ? "Cancel"
                                            : "Upload New DD214"}
                                    </Button>
                                </Col>
                            )}
                            <Card.Header
                                style={{
                                    display: "flex",

                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <h5 className="border-bottom border-warning border-5">
                                    Upload Veteran&apos;s Preference Application
                                </h5>
                            </Card.Header>
                            <Card.Body>
                                {profile.Veteran_Preference_ApplicationFormIn ===
                                    "Yes" && (
                                        <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                            <Col className="py-3">
                                                <Row>
                                                    <Col className="text-center">
                                                        <h5 className="border-bottom border-warning border-5">
                                                            {" "}
                                                            Current Veteran&apos;s
                                                            Preference Application
                                                            On File:
                                                        </h5>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <b>File Name:</b>{" "}
                                                        {
                                                            profile.Veteran_Preference_ApplicationForm_OriginalName
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <b>Upload Date:</b>{" "}
                                                        {formateUploadDate(
                                                            profile.Veteran_Preference_ApplicationForm_UploadDate,
                                                        )}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <b>Size:</b>{" "}
                                                        {profile.Veteran_Preference_ApplicationForm_FileSize
                                                            ? prettyBytes(
                                                                parseInt(
                                                                    profile.Veteran_Preference_ApplicationForm_FileSize,
                                                                ),
                                                            )
                                                            : ""}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <FileUploadDelete
                                                        containerName={
                                                            "Veteran_Preference_ApplicationForm"
                                                        }
                                                        fileName={
                                                            profile.Veteran_Preference_ApplicationForm_OriginalName
                                                        }
                                                    />
                                                </Row>
                                            </Col>
                                        </Row>
                                    )}
                            </Card.Body>
                            {uploadVeteranPrefApp && (
                                <FileUpload
                                    containerName={
                                        "Veteran_Preference_ApplicationForm"
                                    }
                                />
                            )}
                            {profile.Veteran_Preference_ApplicationFormIn ===
                                "No" &&
                                !uploadVeteranPrefApp && (
                                    <Col className="d-flex justify-content-center mb-4">
                                        <Button
                                            variant="primary"
                                            className={
                                                uploadVeteranPrefApp
                                                    ? "btn-danger"
                                                    : ""
                                            }
                                            onClick={() =>
                                                setUploadVeteranPrefApp(
                                                    !uploadVeteranPrefApp,
                                                )
                                            }
                                        >
                                            {uploadVeteranPrefApp
                                                ? "Cancel"
                                                : "Upload New Veteran Preference Application"}
                                        </Button>
                                    </Col>
                                )}
                            <Card.Footer>
                                <Row className="text-center">
                                    <Col sm={6} xs={12}>
                                        <h5>
                                            <u>Required Information:</u>
                                        </h5>
                                        <h5>
                                            {profile.DD214OnFile === "Yes" ? (
                                                <>
                                                    <GrCheckboxSelected className="text-success" />
                                                    &nbsp;DD-214/DD-215 has been submitted.
                                                </>
                                            ) : (
                                                <>
                                                    <GrCheckbox />
                                                    &nbsp;DD-214/DD-215 is required
                                                </>
                                            )}
                                        </h5>
                                        <h5>
                                            {profile.Veteran_Preference_ApplicationFormIn === "Yes" ? (
                                                <>
                                                    <GrCheckboxSelected className="text-success" />
                                                    &nbsp;Veteran&apos;s Preference
                                                    Application has been submitted.
                                                </>
                                            ) : (
                                                <>
                                                    <GrCheckbox />
                                                    &nbsp;Veteran&apos;s Preference
                                                    Application is required.
                                                </>
                                            )}
                                        </h5>
                                    </Col>
                                    <Col sm={6} xs={12} className="mb-3">
                                        <h5>
                                            <u>
                                                Veterans Preference Status:
                                            </u>
                                        </h5>
                                        {values.veteran === "Yes" &&
                                            (profile.DD214OnFile === "No" ||
                                                profile.Veteran_Preference_ApplicationFormIn === "No") && (
                                                <>
                                                    <h5 className="text-danger underline">
                                                        Currently not eligible for preference.
                                                    </h5>
                                                    <p className="text-danger fst-italic">
                                                        You are lacking ONE or MULTIPLE forms to be eligible for this preference.
                                                    </p>
                                                </>
                                            ) ||
                                            (profile.DD214OnFile === "Yes" &&
                                                profile.Veteran_Preference_ApplicationFormIn === "Yes") && (
                                                <h5 className="text-success">
                                                    Currently eligible
                                                    for preference.
                                                </h5>
                                            )}
                                    </Col>
                                </Row>
                            </Card.Footer>
                        </Card>
                    </>
                )}
            </Container >
        </>
    );
};
